import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { AutocompleteInput } from '../../../Components/Inputs/AutocompleteInput'
import { InputOptionProps } from '../../../Components/Inputs/Types'
import { AppPermission, useAppPermissions } from '../../../Hooks/useAppPermissions'
import { LabSchema } from '../../../Schema/LabSchema'
import { useLabsSelector } from '../Hooks/useLabsSelector'
import { LabAddDrawer } from '../LabAddDrawer'

interface LabPickerProps {
  value?: string
  className?: any
  label?: string
  helperText?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  onCreateNew?: (text: string) => void
  enableCreate?: boolean
  error?: boolean
}

export const LabPicker: React.FC<LabPickerProps> = ({
  className,
  value,
  label,
  helperText,
  onChange,
  disabled,
  required,
  variant,
  placeholder,
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate = true,
  error,
}) => {
  const { checkPermissions } = useAppPermissions()

  const [openAdd, setOpenAdd] = useState(false)
  const [text, setText] = useState<string>('')

  const labs = useLabsSelector()
  const options: InputOptionProps[] = useMemo(() => {
    return _.map(labs, lab => lab.getInputOption())
  }, [labs])

  const handleOnCreate = (name?: string) => {
    setOpenAdd(true)
    setText(
      name,
    )
  }

  const handleOnCloseAdd = (lab?: LabSchema) => {
    if (lab) {
      onChange(lab.id)
    }
    setOpenAdd(false)
  }
  return (
    <>
    <AutocompleteInput
      value={value}
      className={className}
      label={label}
      helperText={helperText}
      onChange={value => onChange(value as string)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      options={options}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      onCreateNew={handleOnCreate}
      enableCreate={checkPermissions([AppPermission.LabContactAdd]) && enableCreate}
      error={error}
    />
    {openAdd && <LabAddDrawer
      defaultData={{
        name: text,
      }}
      open={openAdd}
      onClose={handleOnCloseAdd}
    />}
    </>
  )
}
